import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-passwords',
  templateUrl: './passwords.component.html',
  styleUrls: ['./passwords.component.scss'],
})
export class PasswordsComponent implements OnInit {

  @Input() spinner = false;

  @Output() newPass = new EventEmitter<string>();

  public newPassword = '';
  public invalidPassConfirm = false; // Si el formulario de nueva contraseña es inválido

  constructor() { }

  ngOnInit() { }

}
